module.exports = __webpack_public_path__ + "static/media/eyes.197c0fdd.svg";